import { PHOTOS_URL } from "../../../constants";

function ClubText({ component: Component, ...props }: any) {
  return (
    <div
      className="clubText"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignContent: "baseline",
        margin: "10px 0px",
      }}
    >
      <div className="innerPhoto">
        <img src={PHOTOS_URL + props.img} alt={props.img} />
      </div>
      <div className="innerText">
        <p
          style={{ margin: 0, marginLeft: 10 }}
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      </div>
    </div>
  );
}
export default ClubText;
